import type { NoteSchema } from '@libs/data-access/queries'
import { weeklyScheduleService } from '@libs/data-access/queries'
import { Loader, Modal, defineModal } from '@libs/ui/ds'
import type { FC } from 'react'
import React, { useMemo } from 'react'

import NoteForm from './NoteForm/NoteForm'
import { useNote } from './useNote'

type NoteModalProps = {
  noteId?: number
  weeklyscheduleId: number
  date: 'YY-MM-DD' | string
}

export const noteModalDef = defineModal<NoteModalProps>({
  name: 'noteModal'
})

const NoteModal: FC = () => {
  const { close, isOpen, data } = noteModalDef.useModal()

  const { postNoteMutation, putNoteMutation, deleteNoteMutation } = useNote()

  const formType = data?.noteId ? 'edit' : 'create'

  const weeklyScheduleQuery = weeklyScheduleService.api.useFetchOne({
    pathParams: { id: data?.weeklyscheduleId }
  })

  const noteStub: Partial<NoteSchema> = useMemo(() => {
    return {
      note: undefined,
      date: data?.date,
      weeklyschedule_id: data?.weeklyscheduleId
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data?.date])

  if (weeklyScheduleQuery.isLoading || weeklyScheduleQuery.isFetching) {
    return <Loader.Container />
  }

  const note = weeklyScheduleQuery.data?.daily_notes.find(
    note => note.id === data?.noteId
  )

  const handleSubmit = (note, newNote) => {
    if (formType === 'create') {
      postNoteMutation.mutate({
        payload: { ...note, ...newNote }
      })
    }

    if (formType === 'edit' && data?.noteId) {
      putNoteMutation.mutate({
        pathParams: {
          id: data.noteId
        },
        payload: { ...note, ...newNote }
      })
    }

    close()
  }

  const handleDelete = () => {
    if (data?.noteId) {
      deleteNoteMutation.mutate({ pathParams: { id: data.noteId } })
    }
    close()
  }

  return (
    <Modal variant='center' size='s' opened={isOpen} onClose={close}>
      <NoteForm
        note={formType === 'edit' ? note : noteStub}
        onSubmit={handleSubmit}
        onNoteDelete={handleDelete}
      />
    </Modal>
  )
}

export default noteModalDef.withModalShow(NoteModal)
